var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_c('v-list-group',{attrs:{"value":true,"prepend-icon":_vm.icon,"color":"white"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-title',[_vm._v(_vm._s(_vm.activatorTitle))])]},proxy:true}])},[_c('v-list-item-group',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }